// Ensure window.Shopify exists
window.Shopify = window.Shopify || {};

// Ensure window.Shopify.theme exists
window.Shopify.theme = window.Shopify.theme || {};

// Only set theme_store_id if it hasn't been defined yet
if (typeof window.Shopify.theme.theme_store_id === 'undefined') {
  window.Shopify.theme.theme_store_id = 135017627763; // Replace with your desired value
}
if (typeof specialProduct !== 'undefined' && specialProduct ) {
  stores.sort(function(a, b){
    if(a.name < b.name) { return -1; }
    if(a.name > b.name) { return 1; }
    return 0;
  })
}

window.onload = function() { 
    jQuery.getJSON('/cart', function(e){
      var items = e.items;
      for (var i in items) {
        if(items[i].title === "Pickup Instore") {
          var tt = setInterval(function(){disableCheckoutButton();}, 1000);
          setTimeout(function() { clearInterval(tt); }, 5000);        	
        }
      }
    })
    
    
  };
document.addEventListener('crPickupActivated', function (e) { 
    console.log('____ activated _____');
    if (typeof specialProduct !== 'undefined' && specialProduct) {
      jqCR('#pickup-name-label, #pickup-first-name, #pickup-last-name').hide();
    }
    // debug start 
    var debugData = '';
    navigator.sayswho= (function(){
      var ua= navigator.userAgent, tem, 
      M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
      if(/trident/i.test(M[1])){
          tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
          return 'IE '+(tem[1] || '');
      }
      if(M[1]=== 'Chrome'){
          tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
          if(tem!= null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
      }
      M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
      if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
      return M.join(' ');
    })();
    var x = document.getElementById("pickup-container");
    debugData += "Date: " + new Date() + "; Browser: " + navigator.sayswho + "; Pickup container: " + window.getComputedStyle(x).display;
    // debug end

    
    disableCheckoutButton();
    var tt = setInterval(function(){disableCheckoutButton();}, 1000);
    setTimeout(function() { clearInterval(tt); }, 5000);  

  jqCR('#pickup-date-start, #note-pickup-date, #pickup-first-name, #pickup-last-name, #pickup-number').on('mouseout keyup change', function(){
  	//console.log('check for others and activate checkout')  	
    checkPickupFields()
  })
  
  jqCR(document).on('change', '#pickup-selected-store', function(){checkPickupFields()})
  
  trackChange( jqCR("#pickup-selected-store")[0] );  
  
  jqCR('[name=checkout]').on('click', function(e){
    jqCR('#js-debug-browser').val(debugData)
    if (jqCR('#pickup-selected-store').val() == '') {
      e.preventDefault();
      location.href = "/cart";
      location.reload()
    }  	
  })
});


MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

var trackChange = function(element) {
  var observer = new MutationObserver(function(mutations, observer) {
    if(mutations[0].attributeName == "value") {
        jqCR(element).trigger("change");
    }
  });
  observer.observe(element, {
    attributes: true
  });
}

function checkPickupFields(){
  	var pickupDate = jqCR('#pickup-date-start').val();
    var firstName = jqCR('#pickup-first-name').val();
    var lastName = jqCR('#pickup-last-name').val();
    var phone = jqCR('#pickup-number').val();
    var selectedStoreId = jqCR('#pickup-selected-store-id').val()
    if (typeof specialProduct !== 'undefined' && specialProduct && selectedStoreId && phone) {
      activateCheckoutButton();
    } else if (selectedStoreId && firstName && lastName && phone) {
    	activateCheckoutButton();
    } else {
    	disableCheckoutButton()
    }
}

function activateCheckoutButton(){
    if (document.querySelector('[name=checkout]')) {
	    document.querySelector('[name=checkout]').disabled = false;
    }
  }

function disableCheckoutButton(){    
  if (document.querySelector('[name=checkout]')) {
    document.querySelector('[name=checkout]').disabled = true;
  }    
}